import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import {DataRest, IdDataRest, SchedulesData } from '../model/api/data-rest';
import { environment } from 'src/environments/environment';
import { resources } from './api';
import { Schedule } from '../model/schedule';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getSchedules(userId?: number, siteId?: number): Observable<SchedulesData> {
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        if (siteId) {
            return this.http.get<SchedulesData>(
                `${environment.apiUrl}${resources.get('schedules')}${resources.get('by')}${resources.get('site')}/${siteId}`,
                { params }
            );
        }
        return this.http.get<SchedulesData>(`${environment.apiUrl}${resources.get('schedules')}`, { params });
    }

    addSchedule(schedule: Schedule): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('schedules')}`, schedule);
    }

    deleteSchedule(scheduleId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('schedules')}/${scheduleId}`);
    }

    editSchedule(schedule: Schedule): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('schedules')}/${schedule.Id}`, schedule);
    }
}

